import { Navigate, Outlet, createHashRouter } from "react-router";

import { Layout } from "./components/Layout";
import { RouteError } from "./components/RouteError";
import { useToken } from "./lib/auth";
import { ActivityPage } from "./pages/Activity";
import { FoodsPage } from "./pages/Foods";
import { GoalsPage } from "./pages/Goals";
import { LoginPage, RegisterPage } from "./pages/Login";
import { SettingsPage } from "./pages/Settings";
import { TodayPage } from "./pages/Today";

function RequireAuth() {
  return useToken() ? <Outlet /> : <Navigate to="/login" replace />;
}

function RequireGuest() {
  return useToken() ? <Navigate to="/" replace /> : <Outlet />;
}

// Hash URLs (#/history) need no server rewrite rules, so the build works on any static host.
export const router = createHashRouter([
  {
    errorElement: <RouteError />,
    element: <RequireGuest />,
    children: [
      { path: "/login", element: <LoginPage />, errorElement: <RouteError /> },
      { path: "/register", element: <RegisterPage />, errorElement: <RouteError /> },
    ],
  },
  {
    element: <RequireAuth />,
    errorElement: <RouteError />,
    children: [
      {
        element: <Layout />,
        // Errors inside a page keep the menu, so you can still go elsewhere.
        children: [
          { path: "/", element: <TodayPage />, errorElement: <RouteError /> },
          // Charts are heavy, so this page loads on first visit.
          {
            path: "/history",
            errorElement: <RouteError />,
            lazy: () => import("./pages/History").then((m) => ({ Component: m.HistoryPage })),
          },
          { path: "/foods", element: <FoodsPage />, errorElement: <RouteError /> },
          { path: "/goals", element: <GoalsPage />, errorElement: <RouteError /> },
          { path: "/activity", element: <ActivityPage />, errorElement: <RouteError /> },
          { path: "/settings", element: <SettingsPage />, errorElement: <RouteError /> },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
